module.exports = __webpack_public_path__ + "static/tread-softly-869d2dc62da3cc4d6a63453880660691.jpg";